/**
 * Custom Functionality for modal popups
 * @type {Object}
 */
SITE.Modals = {

	Topbar: {
		init: function(){

			$('[data-segmentation-tooltip]').tooltip({
				trigger: 'hover'
			});
			
			if ($('body').attr('data-page') == 'thank-you' || $('body').hasClass('post-slug-free-consultation') || $('body').hasClass('conversion-page')) return;
			
			// close all tooltipswhen a modal opens
			$('.modal').on('shown.bs.modal', function () {
				$('[data-toggle=tooltip]').tooltip('hide');
			});

			if ( Cookies.get("topbar-dismissed") == 1 ){
				// idle	
			} else {
				$topbar = $('[data-topbar]');
				$topbar.slideDown();
				$('[data-topbar-tooltip]').tooltip();
				$('[data-topbar-close]').on('click', function(){
					Cookies.set("topbar-dismissed", 1, { expires: 365 });
					$topbar.slideUp();
				});
			}
		}
	},

	/*Videoplayer: {
		init: function(){
			var $videoModal = $("#videoModal");

			var $videoSrc;  
			$('[data-video-btn]').click(function() {
				$videoSrc = $(this).data( "src" );
			});

			$videoModal.on('shown.bs.modal', function (e) {
				$("[modal-video]").attr('src',$videoSrc + "?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1" ); 
			});

			// stop playing the video when I close the modal
			$videoModal.on('hide.bs.modal', function (e) {
				$("[modal-video]").removeAttr('src'); 
			}) 
		}
	},*/

	ContactFormAlt: {

		init: function() {
			"use strict";

			var parent = $("#contactModalAlt");

			// If on mobile, insert extra field
			if (SITE.UI.viewport.mode === 'xs') {
				parent.find("form").append("<input type='hidden' name='fields[from_mobile]' value='true'>");
			}

			SITE.Modals.ContactFormAlt.recordServicesNeeded();

			//SITE.Modals.TabbedForm.slider(document.getElementById('budgetSliderAlt'));

			// Toggle "Other" text field
			parent.find("[data-toggle='other-field']").click(function() {

				if ($(this).find("input[type=checkbox]").is(':checked')) {
				
					$("#" + $(this).data("target")).slideDown();
				
				} else {
					
					$("#" + $(this).data("target"))
						.slideUp()
						.find("textarea").val("");
				}
			});

			/*
			// On mobile, hide intercom when form is open
			$('#contactModalAlt')
				.on('hidden.bs.modal', function (e) {

					if (SITE.UI.viewport.mode === 'xs') $("#intercom-container").show();

				})
				.on('shown.bs.modal', function (e) {
					
					if (SITE.UI.viewport.mode === 'xs') $("#intercom-container").hide();

				});
			*/

		},

		/**
		 * Record Services Needed
		 * -----------------------
		 * Drip forms can't accept checkboxes. So we need
		 * to save the results into a text field. 
		 * 
		 * @return {[type]} [description]
		 */
		recordServicesNeeded: function() {
			"use strict";

			var checkboxes  = $("#cfSvcsGrpAlt input[type=checkbox]"), 
				txtField    = $("#cfServicesAlt"),
				svcs        = "";

			checkboxes.change(function() {
				svcs = "";
				checkboxes.filter(":checked").each(function() {
					if (svcs !== "") svcs += ", ";
					svcs += $(this).val();
				});
				txtField.val(svcs);
			});
		}

	},

	/**
	 * Standard Tabbed Modal Form
	 * --------------------------
	 * Popup CTA form with multiple steps
	 * for user input
	 * 
	 * @type {Object}
	 */
	TabbedForm: {

		partialDataAdded: false,

		/* Notes: 
			On modal show:
			 - i need to reset current step to 1
			 - reset checkboxes val
		*/

		/**
		 * Initialize Forms
		 * -----------------
		 * 1. Identify forms by [data-role=tabbed-form]
		 * 2. 
		 * 
		 * @return {[type]} [description]
		 */

		init: function() {
			"use strict";

			var parent, val;

			// Initiate NoUiSlider
			this.slider(document.getElementById('budgetSlider'));

			// Record Page URL
			$('#cfPage').val(window.location.href);

			// Check URL and Enable if needed
			if (window.location.hash === "#contactModal") $("#contactModal").modal("show");
			if (window.location.hash === "#getStartedModal") $("#getStartedModal").modal("show");

			$("[data-role='tabbed-form']").each(function() {

				parent = $(this);

				// Record total number of steps 
				parent.data('total-steps', parent.find('.tab').length);
				parent.data('current-step', 1);

				// Handle Continue Button
				parent.find("[data-toggle='form-advance']").click(function() {

					// First set submission URL
					var dripFormId = parent.find("form").data('drip-id');

					if(dripFormId) {
						parent.find("form").attr('action', 'https://www.getdrip.com/forms/' + dripFormId + '/submissions');
					} else {
						parent.find("form").attr('action', 'https://www.getdrip.com/forms/87353426/submissions');
					}

					// Change service based on lead segment
					$("#cfBudget").trigger('change');

					// Here was the checkbox toggles, moved to `fn reset`
					
					if (SITE.Modals.TabbedForm.isValid(parent)) {

						val = $('#cfPhone').val();
						
						// Send Main Contact Info to Drip
						if (!SITE.Modals.TabbedForm.partialDataAdded) {
							SITE.Drip.push("subscribe", {
														campaign_id: "85026915",
														fields: {
															email:      $('#cfEmail').val(),
															name:       $('#cfName').val(),
															phone:      $('#cfPhone').val(),
															url:        $('#cfUrl').val(),
															page:       $('#cfPage').val(),
															partial:    "true"
														},
														double_optin: false,
														success: function() {
															SITE.Modals.TabbedForm.partialDataAdded = true;
														}
							});
						}

						SITE.Modals.TabbedForm.advanceForm(parent, 1);
					}

				});

				// Handle Back Button
				parent.find("[data-toggle='form-reverse']").click(function() {
					SITE.Modals.TabbedForm.advanceForm(parent, -1);
				});

				// Toggle "Other" text field
				parent.find("[data-toggle='other-field']").click(function() {

					if ($(this).find("input[type=checkbox]").is(':checked')) {
					
						$("#" + $(this).data("target")).slideDown();
					
					} else {
						
						$("#" + $(this).data("target"))
							.slideUp()
							.find("textarea").val("");
					}
				});


				// Record Services Field
				SITE.Modals.TabbedForm.recordServicesNeeded();

				// Know when modal is on or off
				$('#contactModal')
					.on('hidden.bs.modal', function (e) {

						SITE.Tracking.Conversions.track($("#freeConsultForm").data('tracking'), 'dismiss');
						SITE.Marketing.activeNow = "";

					})
					.on('shown.bs.modal', function (e) {

						SITE.Modals.TabbedForm.reset();
						
						var track = $(e.relatedTarget).data('track-type');
						if (typeof track === "undefined") {
							track = $(e.relatedTarget).data('track-type-m');
						}
						$("#freeConsultForm").data('tracking', track);
						SITE.Tracking.Conversions.track(track, 'click');

						SITE.Marketing.activeNow = "Get In Touch";
					});

			});

		},

		reset: function() {
			$("#cfSvcsGrp .dfy-svc").hide();
			$("#cfSvcsGrp .dwy-svc").hide();

			if($('#freeConsultLeadSegment').val() != '') {

				if($('#freeConsultLeadSegment').val() == 'done-with-you') {
					 $("#cfSvcsGrp .dwy-svc").show();
				}

				if($('#freeConsultLeadSegment').val() == 'done-for-you') {
					$("#cfSvcsGrp .dfy-svc").show();
				}
			}

			// Reset checkboxes
			$('.checkbox.dfy-svc, .checkbox.dwy-svc').find('input[type=checkbox]').prop('checked', false);
		},

		/**
		 * Move form forward one tab
		 * @return {[type]} [description]
		 */
		advanceForm: function(container, direction) {
			"use strict";

			var step        = container.data('current-step'),
				totalSteps  = container.data('total-steps'),
				txt, btn;

			step += direction;

			// Toggle CSS Styles for states
			if (step > 1)   container.addClass('past-first-base');
			else            container.removeClass('past-first-base');

			if (step <= totalSteps) {

				// Advance
				container.find('.tab')
					.removeClass('active')
					.eq(step - 1).addClass('active');

				container.find('.step-indicator li')
					.removeClass('active')
					.eq(step - 1).addClass('active');
				
				container.data('current-step', step);

				btn = container.find(".btn-primary");
				
				if (step === totalSteps) {
					btn.data('original-text', btn.text());
					txt = btn.data('step-final-text');
				} else {
					txt = btn.data('original-text');
				}

				if (typeof txt !== "undefined" && txt !== "") btn.text(txt);

			} else {
				
				// Submit
				container.find("form").submit();
			}
		},

		/**
		 * Validate Current Step
		 * @return {Boolean} [description]
		 */
		isValid: function(container) {
			"use strict";

			var valid = true,
				tab = container.find('.tab.active'),
				validator = $('#freeConsultForm').validate();

			tab.find('.form-control').each(function() {

				// Handle some mobile fields
				if ($(this).is("[required]") || $(this).is("[data-required]")) {

					if(($(this).data("required") === "desktop-only" 
						  && SITE.UI.viewport.mode === "xs")) {

						// Remove this attribute from the field
						$(this).removeAttr('required');

					}

				}

				// Run through jQuery Validation
				if ( ! validator.element(this) && valid) {
					valid = false;
				}

			});

			return valid;

		},

		/**
		 * Initiate Slider used on Contact Form Modal
		 * ------------------------------------------
		 * http://refreshless.com/nouislider/
		 * 
		 * @return {[type]} [description]
		 */
		slider: function(slider) {
			"use strict";

			var slider, range, val, i;

			// Change Service Based on Budget
			$("#cfBudget").change(function() {

				SITE.Modals.TabbedForm.updateDripFormId($(this).val());

				/*switch ($(this).val()) {

					case "$0 - $1,000":
						$("#cfSvcsGrp .sme-svc").show();
						$("#cfSvcsGrp .corp-svc").hide();
						break;

					case "$1,000 - $5,000":
					case "$5,000 - $10,000":
						$("#cfSvcsGrp .sme-svc").hide();
						$("#cfSvcsGrp .corp-svc").hide();
						$("#cfSvcsGrp .md-svc").show();
						break;

					default:
						$("#cfSvcsGrp .corp-svc").show();
						$("#cfSvcsGrp .sme-svc").hide();
				}*/
			});

			// If touch device, enable dropdown instead
			if (SITE.UI.viewport.touch || SITE.UI.viewport.mode === "xs") {
				$('#cfBudget').show();
				$("#budgetSlider").addClass("dropdown-only");
				return true;
			}

			

			// Setup Slider
			range = [
				"$0 - $1,000",
				"$1,000 - $5,000",
				"$5,000 - $10,000",
				"$10,000 - $20,000",
				"$20,000 - $40,000",
				"$40,000 - $80,000",
				"$80,000 - $160,000",
				"$160,000+"
			];
			
			noUiSlider.create(slider, {
				start: [3],
				step: 1,
				range: {
					'min': [  0 ],
					'max': [  7 ]
				}
			});

			slider.noUiSlider.on('update', function( values, handle ){
				
				i = parseInt(values[handle]);
				val = range[i];
				
				handle = $(slider).find(".noUi-handle");
				handle
					.attr("data-title", val)
					.removeClass("min")
					.removeClass("max");

				if (i === 0) handle.addClass("min");
				if (i === 5) handle.addClass("max");

				$("#cfBudget").val(val).trigger("change");
				
			});

		},

		/**
		 * Update Drip form ID depending on budget.
		 *
		 * @param string budget
		 *
		 * @return void
		 */
		updateDripFormId: function(budget) {
			"use strict";

			var leadSegment = $('#freeConsultLeadSegment').val();
			var freeConsultForm = $('#freeConsultForm');
			var defaultFormId = 87353426;
			var lowBudgetFormId = 207494258;

			if(leadSegment == 'done-with-you') {
				if(budget == '$0 - $1,000') {
					freeConsultForm.attr('action', 'https://www.getdrip.com/forms/' + lowBudgetFormId + '/submissions');
					freeConsultForm.attr('data-drip-embedded-form', lowBudgetFormId);
					freeConsultForm.attr('data-drip-id', lowBudgetFormId);
				} else {
					freeConsultForm.attr('action', 'https://www.getdrip.com/forms/' + defaultFormId + '/submissions');
					freeConsultForm.attr('data-drip-embedded-form', defaultFormId);
					freeConsultForm.attr('data-drip-id', defaultFormId);
				}
			}

			if(leadSegment == 'done-for-you') {
				if( budget == '$0 - $1,000' || budget == '$1,000 - $5,000' ) {
					freeConsultForm.attr('action', 'https://www.getdrip.com/forms/' + lowBudgetFormId + '/submissions');
					freeConsultForm.attr('data-drip-embedded-form', lowBudgetFormId);
					freeConsultForm.attr('data-drip-id', lowBudgetFormId);
				} else {
					freeConsultForm.attr('action', 'https://www.getdrip.com/forms/' + defaultFormId + '/submissions');
					freeConsultForm.attr('data-drip-embedded-form', defaultFormId);
					freeConsultForm.attr('data-drip-id', defaultFormId);
				}
			}
		},

		/**
		 * Record Services Needed
		 * -----------------------
		 * Drip forms can't accept checkboxes. So we need
		 * to save the results into a text field. 
		 * 
		 * @return {[type]} [description]
		 */
		recordServicesNeeded: function() {
			"use strict";

			var checkboxes  = $("#cfSvcsGrp input[type=checkbox]"), 
				txtField    = $("#cfServices"),
				svcs        = "";

			checkboxes.change(function() {
				svcs = "";
				checkboxes.filter(":checked").each(function() {
					if (svcs !== "") svcs += ", ";
					svcs += $(this).val();
				});
				txtField.val(svcs);
			});
		}
	},


	SignupForm: {

		init: function() {
			"use strict";

			var el = $('#signupModal'),
				form = el.find('form'),
				dripId = "",
				hf,
				deliverable;

			el.on('show.bs.modal', function (event) {
				var btn = $(event.relatedTarget), // Button that triggered the modal
					modal = $(this);
				
				dripId = btn.data("dripid");
				deliverable = btn.data("deliverable");

				modal.find('.modal-body .h2').html(btn.data("headline"));
				modal.find('.modal-body .subheading').html(btn.data("subheading"));
				modal.find('.modal-body #cfDeliverable').val(deliverable);
				modal.find('.modal-body #resourceLeadMagnet').val('Free Resource (' + deliverable + ')');

				if (typeof btn.data("request") !== "undefined")  {
					hf = modal.find("input[name='fields[request]']");
					
					if (hf.length === 0) {
					
						hf = $("<input type='hidden' name='fields[request]' value='" + btn.data("request") + "'>");
						modal.find('.modal-body').append(hf);
					
					} else {
					
						hf.val(btn.data("request"));
					
					}   
				}

				form
					.attr("action", "https://www.getdrip.com/forms/" + dripId + "/submissions")
					.attr("data-drip-embedded-form", dripId);

				// Close on submit
				form.on('submit', function(e) {
					e.preventDefault();

					// Sometimes, for some reason, data is lost, need to recreate it
					if(typeof(dripId) == 'undefined') {
						
						dripId = btn.data("dripid");
						deliverable = btn.data("deliverable");

						modal.find('.modal-body #cfDeliverable').val(deliverable);
						form
						.attr("action", "https://www.getdrip.com/forms/" + dripId + "/submissions")
						.attr("data-drip-embedded-form", dripId);

					}

					// Submit the form
					this.submit();

					// Close the modal
					$('#signupModal').modal('toggle');
					$('.modal-backdrop').removeClass('in').addClass('out');

					return true;
				});
			});

			$('#signupModal')
				.on('hidden.bs.modal', function (e) {
					SITE.Marketing.activeNow = "";
					SITE.Tracking.Conversions.track($("#modalSignupForm").data('tracking'), 'dismiss');
				})
				.on('shown.bs.modal', function (e) {

					var track = $(e.relatedTarget).data('track-type');
					$("#modalSignupForm").data('tracking', track);
					SITE.Tracking.Conversions.track(track, 'click');

					SITE.Marketing.activeNow = "Signup Modal";

					// If header bar is on it needs to be hidden
					SITE.Marketing.HeaderBar.hide();
				});

		}
	},

};